import { call, put, takeLatest } from "@redux-saga/core/effects";
import { DASHBOARD_ACTION, errorDashboardList, errorEmpDashboardList, errorEmpDashboardMonthlyHoursList, responseDashboardList, responseEmpDashboardList, responseEmpDashboardMonthlyHoursList ,responseTimesheetCount ,errorTimesheetCount, responseEmpWishes, errorEmpWishes, responseWeeklyEfficiency, errorWeeklyEfficiency } from "./dashBoardActionCreator";
import DashBoardService from "../../Services/RestApiManager/DashBoardManager/DashBoardService";

export function* dashBoardRequestSaga(action) {
    try {
        const response = yield call(DashBoardService.shared.dashBoardListRequest, action.data);
        yield put(responseDashboardList(response));
    } catch (error) {
        yield put(errorDashboardList(error));
    }
}

export function* empDashBoardListRequest(action) {
    try {
      const response = yield call(DashBoardService.shared.empDashBoardListRequest, action.data);
      yield put(responseEmpDashboardList(response));
    } catch (error) {
      yield put(errorEmpDashboardList(error));
    }
  }

  export function* empDashBoardMonthlyHoursRequest(action) {
    try {
      const response = yield call(DashBoardService.shared.empDashBoardMonthlyHoursListRequest, action.data);
      yield put(responseEmpDashboardMonthlyHoursList(response));
    } catch (error) {
      yield put(errorEmpDashboardMonthlyHoursList(error));
    }
  }
  export function* timesheetCountRequest(action) {
    try {
      const response = yield call(DashBoardService.shared.timesheetCountRequest, action.data);
      yield put(responseTimesheetCount(response));
    } catch (error) {
      yield put(errorTimesheetCount(error));
    }
  }

  
  export function* empWishesRequest(action) {
    try {
      const response = yield call(DashBoardService.shared.empWishesRequest, action.data);
      yield put(responseEmpWishes(response));
    } catch (error) {
      yield put(errorEmpWishes(error));
    }
  }

  export function* weeklyEfficiencyRequest(action) {
    try {
      const response = yield call(DashBoardService.shared.weeklyEfficiencyRequest, action.data);
      yield put(responseWeeklyEfficiency(response));
    } catch (error) {
      yield put(errorWeeklyEfficiency(error));
    }
  }

export function* dashBoardWatcherSaga() {
    yield takeLatest(DASHBOARD_ACTION.REQUEST_DASHBOARD_LIST , dashBoardRequestSaga);
    yield takeLatest(DASHBOARD_ACTION.REQUEST_EMP_DASHBOARD_LIST , empDashBoardListRequest);
    yield takeLatest(DASHBOARD_ACTION.REQUEST_EMP_DASHBOARD_MONTHLY_HOURS_LIST , empDashBoardMonthlyHoursRequest);
    yield takeLatest(DASHBOARD_ACTION.REQUEST_TIMESHEET_COUNT , timesheetCountRequest);
    yield takeLatest(DASHBOARD_ACTION.REQUEST_EMP_WISHES , empWishesRequest);
    yield takeLatest(DASHBOARD_ACTION.REQUEST_WEEKLY_EFFECIENCY,weeklyEfficiencyRequest)

}

